import styled, { css } from "styled-components";

interface RawCheckBoxProps {
  error?: boolean;
}

export const RawCheckbox = styled.input.attrs({ type: "checkbox" })<RawCheckBoxProps>`
  position: relative;
  appearance: none;
  width: 1.3rem;
  height: 1.3rem;
  margin: 0.1rem 0.5rem;
  transition: all 0.3s;
  background-color: ${p => p.theme.colors.background.paper};
  border-radius: ${p => p.theme.borderRadius};
  border: 1px solid ${p => p.theme.colors.grey[500]};
  cursor: pointer;
  &::after {
    content: "";
    position: absolute;
    display: none;
  }
  &:checked {
    &::after {
      display: block;
      top: 0.1em;
      left: 0.5em;
      width: 35%;
      height: 70%;
      border: solid ${p => p.theme.colors.common.white};
      border-width: 0 0.2em 0.2em 0;
      transform: rotate(45deg);
    }
    background: ${p => p.theme.colors.primary.main};
    border-color: ${p => p.theme.colors.primary.main};
  }
  ${p => p.error && `border-color: ${p.theme.colors.error.main};`}
  &:disabled {
    cursor: default;
    background: ${p => p.theme.colors.grey[400]};
    border-color: ${p => p.theme.colors.action.disabled};
  }
  & + label {
    color: ${p => p.theme.colors.grey[700]}
    font-weight: 500;
    user-select: none;
    cursor: pointer;
    ${p => p.error && `color: ${p.theme.colors.error.main};`}
    ${p =>
      p.disabled &&
      css`
        cursor: default;
        color: p.theme.colors.action.disabled;
      `}
  }
`;
